import type {
  DismissIncidentAction,
  FetchIncidentsAction,
  FetchIncidentsSuccessAction,
} from "domains/incidents/constants/actionTypes";
import { IncidentTypes } from "domains/incidents/constants/actionTypes";
import type { APIIncident } from "domains/incidents/types";

export const fetchUnresolvedIncidents = (): FetchIncidentsAction => ({
  type: IncidentTypes.FETCH_UNRESOLVED,
});

export const fetchUnresolvedIncidentsSuccess = (payload: APIIncident[]): FetchIncidentsSuccessAction => ({
  type: IncidentTypes.FETCH_UNRESOLVED_SUCCESS,
  payload,
});

export const dismissIncident = (payload: { id: string }): DismissIncidentAction => ({
  type: IncidentTypes.DISMISS_INCIDENT,
  payload,
});
